/* this file is transformed by vux-loader */
/* eslint-disable */
import http from '../axios';
import apiUrl from '../apiUrl';

// 更新名称
export var apiUpdateName = function apiUpdateName() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.updateName,
    method: 'put',
    data: query
  });
};

// 添加地址
export var apiAddress = function apiAddress() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return http.request({
    url: apiUrl.address,
    method: method,
    params: method === 'get' || method === 'delete' ? query : {},
    data: method === 'post' || method === 'put' ? query : {}
  });
};

// 地址列表
export var apiAddressList = function apiAddressList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.addressList,
    method: 'get',
    params: query
  });
};

// 修改密码
export var apiUpdatePwd = function apiUpdatePwd() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.updatePwd,
    method: 'put',
    data: query
  });
};

// 登出
export var apilogout = function apilogout() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.logout,
    method: 'get',
    params: query
  });
};

// 团队列表
export var apigrouplist = function apigrouplist() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.groupList,
    method: 'get',
    params: query
  });
};

// 子账号详情
export var apichildaccountdetail = function apichildaccountdetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.childAccountDetail,
    method: 'get',
    params: query
  });
};

// 升级账号权限
export var apiupdate = function apiupdate() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.update,
    method: 'put',
    data: query
  });
};

// 升级账号权限
export var apiupdatechildren = function apiupdatechildren() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: apiUrl.updateChildren,
    method: 'put',
    data: query
  });
};

//公司名称
export var apicorporation = function apicorporation() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/product/filedDetail',
    method: 'get',
    params: query
  });
};

//公司添加
export var apiadd = function apiadd() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/product/qrServiceList',
    method: 'get',
    params: query
  });
};

//公司历史
export var apicorporationdata = function apicorporationdata() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/product/getHistoryList',
    method: 'get',
    params: query
  });
};
// 获取文档分类详情
export var getKnowledgeDocTypeList = function getKnowledgeDocTypeList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/knowledgeDoc/getTypeList',
    method: 'get',
    params: query
  });
};

// 获取文档列表
export var getKnowledgeDocList = function getKnowledgeDocList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/knowledgeDoc/getMKnowledgeList',
    method: 'get',
    params: query
  });
};

// 获取文档详情
export var getKnowledgeDocDetail = function getKnowledgeDocDetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/knowledgeDoc/getKnowledgeDetails/ignoreState',
    method: 'get',
    params: query
  });
};
export var getDocTypeList = function getDocTypeList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/knowledgeDoc/getDocTypeList',
    method: 'get',
    params: query
  });
};
export var getKefuGetUrl = function getKefuGetUrl() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/kefu/getUrl',
    method: 'get',
    params: query
  });
};